import * as React from 'react';
import { NoneFoundOverlay } from 'components/ContainerTable';
import { useClearFilters } from '../../utilities';

export const NoShipmentsFoundOverlay: React.FC = () => {
  const clearFilters = useClearFilters(true);
  return <NoneFoundOverlay clearFilters={clearFilters} variant="shipments" className="pt-8" />;
};
NoShipmentsFoundOverlay.displayName = 'Containers.NoShipmentsFoundOverlay';
